'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Period = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDates = require('react-dates');

var _constants = require('react-dates/constants');

var _zhTw = require('./locales/zh-tw.js');

var _zhTw2 = _interopRequireDefault(_zhTw);

var _zhCn = require('./locales/zh-cn.js');

var _zhCn2 = _interopRequireDefault(_zhCn);

var _th = require('./locales/th.js');

var _th2 = _interopRequireDefault(_th);

var _id = require('./locales/id.js');

var _id2 = _interopRequireDefault(_id);

var _fr = require('./locales/fr.js');

var _fr2 = _interopRequireDefault(_fr);

var _ko = require('./locales/ko.js');

var _ko2 = _interopRequireDefault(_ko);

require('./css/styles.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Period = exports.Period = function (_Component) {
  (0, _inherits3.default)(Period, _Component);

  function Period(props) {
    (0, _classCallCheck3.default)(this, Period);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Period.__proto__ || (0, _getPrototypeOf2.default)(Period)).call(this, props));

    _this.state = {
      focusedInput: null,
      disableDates: function disableDates() {}
    };
    _this.onDatesChange = _this.onDatesChange.bind(_this);
    _this.onFocusChange = _this.onFocusChange.bind(_this);

    // TODO: extract locale settings
    // https://confluence.rakuten-it.com/confluence/display/tpdm/World+Readiness+-+Format
    var settings = {
      id_ID: (0, _extends3.default)({}, _id2.default, {
        weekdaysMin: ['Min', 'Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab'],
        week: {
          dow: 1 // start week from Monday
        }
      }),
      en_US: {
        weekdaysMin: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        week: {
          dow: 0 // start week from Sunday
        }
      },
      en_SG: {
        weekdaysMin: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        week: {
          dow: 0 // start week from Sunday
        }
      },
      en_MY: {
        weekdaysMin: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        week: {
          dow: 0 // start week from Sunday
        }
      },
      zh_TW: (0, _extends3.default)({}, _zhTw2.default, {
        week: {
          dow: 0 // start week from Sunday
        }
      }),
      ko_KR: (0, _extends3.default)({}, _ko2.default, {
        week: {
          dow: 0 // start week from Sunday
        }
      }),
      zh_CN: (0, _extends3.default)({}, _zhCn2.default, {
        week: {
          dow: 0 // start week from Sunday
        }
      }),
      th_TH: (0, _extends3.default)({}, _th2.default, {
        week: {
          dow: 0 // start week from Sunday
        }
      }),
      fr_FR: (0, _extends3.default)({}, _fr2.default, {
        // XXX: according to the PRD on Dec 18, 2014 https://confluence.rakuten-it.com/confluence/pages/viewpage.action?pageId=396531472
        //      I'm not going to change these back to 'dim.' in the future.
        months: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
        weekdaysMin: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
        week: {
          dow: 0 // start week from Sunday
        }
      })
    };
    var locale = props.lang.replace('_', '-');
    if (settings[props.lang]) {
      _moment2.default.updateLocale(locale, settings[props.lang]);
    }
    _moment2.default.locale(locale);
    return _this;
  }

  (0, _createClass3.default)(Period, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      // while clicking check rates button, should focus on picker
      if (!this.state.focusedInput && newProps.focusedInput) {
        this.setState({ focusedInput: newProps.focusedInput });
        this.pickerWrapper.scrollIntoView();
      }
    }
  }, {
    key: 'onDatesChange',
    value: function onDatesChange(_ref) {
      var startDate = _ref.startDate,
          endDate = _ref.endDate;

      switch (this.state.focusedInput) {
        case _constants.START_DATE:
          this.props.onStartDateChange((0, _moment2.default)(startDate).format('YYYY-MM-DD'));
          if (!this.props.endDate || (0, _moment2.default)(startDate).isSameOrAfter((0, _moment2.default)(this.props.endDate))) {
            this.setState({ focusedInput: _constants.END_DATE });
          } else {
            this.setState({ focusedInput: null });
          }
          break;
        case _constants.END_DATE:
          this.props.onEndDateChange((0, _moment2.default)(endDate || startDate).format('YYYY-MM-DD'));
          this.setState({ focusedInput: null });
          break;
        default:
      }
    }
  }, {
    key: 'onFocusChange',
    value: function onFocusChange(focusedInput) {
      var _this2 = this;

      this.setState({
        focusedInput: focusedInput,
        disableDates: focusedInput === _constants.START_DATE ? function (day) {
          return day.startOf('day').isBefore(_this2.props.disableStartDatesBefore.startOf('day')) || day.startOf('day').isAfter(_this2.props.disableStartDatesAfter.startOf('day'));
        } : focusedInput === _constants.END_DATE ? function (day) {
          return day.startOf('day').isBefore(_this2.props.disableEndDatesBefore.startOf('day')) || day.startOf('day').isAfter(_this2.props.disableEndDatesAfter.startOf('day'));
        } : undefined
      });
      this.props.onFocusChange(focusedInput);
    }
  }, {
    key: 'shouldHidePrevMonth',
    value: function shouldHidePrevMonth(currentMonth, focusedInput) {
      return focusedInput === _constants.START_DATE ? currentMonth.isBefore(this.props.disableStartDatesBefore) : focusedInput === _constants.END_DATE ? currentMonth.isBefore(this.props.disableEndDatesBefore) : false;
    }
  }, {
    key: 'shouldHideNextMonth',
    value: function shouldHideNextMonth(currentMonth, focusedInput) {
      return focusedInput === _constants.START_DATE ? currentMonth.add(1, 'months').isAfter(this.props.disableStartDatesAfter) : focusedInput === _constants.END_DATE ? currentMonth.add(1, 'months').isAfter(this.props.disableEndDatesAfter) : false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var numberOfMonths = 1;
      return _react2.default.createElement(
        'div',
        {
          className: 'period-container',
          ref: function ref(wrapper) {
            _this3.pickerWrapper = wrapper;
          }
        },
        _react2.default.createElement(_reactDates.DateRangePicker, {
          displayFormat: this.props.displayFormat,
          monthFormat: this.props.monthFormat,
          startDatePlaceholderText: this.props.startDatePlaceholderText,
          endDatePlaceholderText: this.props.endDatePlaceholderText,
          key: (0, _moment2.default)().toDate().getTime(),
          ref: function ref(elem) {
            _this3.picker = elem;
          },
          onDatesChange: this.onDatesChange,
          onFocusChange: this.onFocusChange,
          isOutsideRange: this.state.disableDates,
          focusedInput: this.state.focusedInput,
          startDate: this.props.startDate ? (0, _moment2.default)(this.props.startDate, 'YYYY-MM-DD') : null,
          endDate: this.props.endDate ? (0, _moment2.default)(this.props.endDate, 'YYYY-MM-DD') : null,
          initialVisibleMonth: function initialVisibleMonth() {
            return _this3.state.focusedInput === _constants.START_DATE && _this3.props.startDate ? (0, _moment2.default)(_this3.props.startDate, 'YYYY-MM-DD') : _this3.state.focusedInput === _constants.END_DATE && _this3.props.endDate ? (0, _moment2.default)(_this3.props.endDate, 'YYYY-MM-DD') : _this3.state.focusedInput === _constants.END_DATE && _this3.props.startDate ? (0, _moment2.default)(_this3.props.startDate, 'YYYY-MM-DD').add(_this3.props.minimumNights, 'day') : (0, _moment2.default)();
          },
          numberOfMonths: numberOfMonths,
          minimumNights: this.props.minimumNights
        })
      );
    }
  }]);
  return Period;
}(_react.Component);
// XXX: workaround for the moment.updateLocale bug


Period.propTypes = {
  lang: _react.PropTypes.string.isRequired,
  displayFormat: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.func]),
  monthFormat: _react.PropTypes.string,
  startDatePlaceholderText: _react.PropTypes.string,
  endDatePlaceholderText: _react.PropTypes.string,
  startDate: _react.PropTypes.string,
  endDate: _react.PropTypes.string,
  onFocusChange: _react.PropTypes.func.isRequired,
  onStartDateChange: _react.PropTypes.func.isRequired,
  onEndDateChange: _react.PropTypes.func.isRequired,
  disableStartDatesBefore: _react.PropTypes.object.isRequired,
  disableStartDatesAfter: _react.PropTypes.object.isRequired,
  disableEndDatesBefore: _react.PropTypes.object.isRequired,
  disableEndDatesAfter: _react.PropTypes.object.isRequired,
  minimumNights: _react.PropTypes.number
};

exports.default = Period;


//////////////////
// WEBPACK FOOTER
// ./src/components/Period/Period.js
// module id = 1212
// module chunks = 0